<template>
  <v-row
    style="align-items:center; justify-content: space-between; margin-bottom: 15px;"
  >
    <v-col
      cols="6"
      sm="8"
      style="display: flex; justify-content: space-between;padding:5px;"
    >
      <v-btn-toggle>
        <div>
          <v-btn
            :class="dateSpan === 'lastWeek'? 'selected-btn' : 'btn' "
            @click="updateDateSpan('lastWeek')"
          >
            <span class="hidden-sm-and-down">{{ $t('graphics.lastWeek') }}</span>
          </v-btn>
          <v-btn
            :class="dateSpan === 'lastMonth' ? 'selected-btn' : 'btn' "
            @click="updateDateSpan('lastMonth')"
          >
            {{ $t('graphics.lastMonth') }}
          </v-btn>
          <v-btn
            :class="dateSpan === 'lastThreeMonths' ? 'selected-btn' : 'btn' "
            @click="updateDateSpan('lastThreeMonths')"
          >
            {{ $t('graphics.lastThreeMonths') }}
          </v-btn>
          <v-btn
            :class="dateSpan === 'lastSixMonths' ? 'selected-btn' : 'btn' "
            @click="updateDateSpan('lastSixMonths')"
          >
            {{ $t('graphics.lastSixMonths') }}
          </v-btn>
        </div>
      </v-btn-toggle>
    </v-col>
    <v-col
      cols="6"
      sm="4"
    >
      <VDatePicker
        v-model="dateRange"
        :label="$t('aquassistBilling.pricingManagement.labels.searchDatePeriod')"
        isRange
        hideDetails
        @input="updateDateRange"
      />
    </v-col>
  </v-row>
</template>

<script>
import VDatePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDatePicker.vue';

export default {
    name: 'DateSelection',
    components: {
        VDatePicker,
    },
    props: {
        selectedDateFilter: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            dateRange: [],
            dateSpan: null,
            selectedDate: {
                relativeRange: '',
                range: [],
            },

        };
    },
    watch: {
        selectedDateFilter: {
            handler() {
                this.dateRange = this.selectedDateFilter.range || [];
                this.dateSpan = this.selectedDateFilter.relativeRange || null;
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        updateDateSpan(span) {
            this.dateRange = [];
            this.dateSpan = span;
            this.$emit('updateDateFilter', { isRange: false, value: this.dateSpan });
        },
        updateDateRange() {
            this.dateSpan = null;
            if (this.dateRange.length === 2) this.$emit('updateDateFilter', { isRange: true, value: this.dateRange });
        },
    },
};
</script>
<style>
.btn{
    margin: 5px 5px 0px 0px;
    transition: none;
    text-transform: none;
}
.selected-btn{
    margin: 5px 5px 0px 0px;
    background-color: #26384B !important;
    color: white !important;
    text-transform: none;
}


</style>
